import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormObjectComponent } from '../../../../shared/forms/form-object.component';
import { EstimateListComponent } from '../estimate-list/estimate-list.component';

@Component({
  selector: 'correction-estimate',
  templateUrl: './correction-estimate.component.html'
})
export class CorrectionEstimateComponent extends FormObjectComponent {
  @ViewChild(EstimateListComponent) estimateList: EstimateListComponent;
  @Output() remove = new EventEmitter<void>();
  
  public override form : UntypedFormGroup;

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      'correction': new UntypedFormControl("", [Validators.required]) 
    });
  }
  
  public override validateForm(): void {
    super.validateForm();

    // If the form is valid so far, check the correction list.
    if (this.formCompleted && this.estimateList) {
      this.estimateList.validateForm();
      this.formCompleted = this.estimateList.formCompleted;
    }
  }

  public removeCorrection(): void {
    this.remove.emit();
  }
}
